// Local
import Animate from './partials/animate';
import UploadControl from "./partials/upload-control";
import FieldsetRepeatable from "./partials/fieldset-repeatable";
import HeroSlider from "./partials/hero-slider";
import ActivityLightbox from "./partials/activity-lightbox";

const initAccordions = ($wrapper) => {
    $wrapper.querySelectorAll('[data-accordion]').forEach((accordion) => {
        const triggers = [...accordion.querySelectorAll('[data-accordion-trigger]')];

        if (!triggers.length || accordion.dataset.accordionInitialized === 'true') {
            return;
        }

        accordion.dataset.accordionInitialized = 'true';

        triggers.forEach((trigger) => {
            trigger.addEventListener('click', () => {
                const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

                triggers.forEach((itemTrigger) => {
                    const panelId = itemTrigger.getAttribute('aria-controls');
                    const panel = panelId ? document.getElementById(panelId) : null;
                    const shouldExpand = itemTrigger === trigger && !isExpanded;

                    itemTrigger.setAttribute('aria-expanded', String(shouldExpand));
                    itemTrigger.closest('.content-accordion__item')?.classList.toggle('is-open', shouldExpand);

                    if (panel) {
                        panel.hidden = !shouldExpand;
                    }
                });
            });
        });
    });
};


window.initDom = ($wrapper) => {
    $wrapper.querySelectorAll('[data-animate]').forEach($item => (new Animate($item)));
    $wrapper.querySelectorAll('[data-upload]').forEach($el => new UploadControl($el));
    $wrapper.querySelectorAll('[data-form-repeatable]').forEach($el => new FieldsetRepeatable($el));
    $wrapper.querySelectorAll('[data-form]').forEach(async ($el) => {
        const Form = await import('./partials/form');
        (new Form.default($el));
    });
    initAccordions($wrapper);
    initHeroSliders($wrapper);
    $wrapper.querySelectorAll('[data-activity-lightbox]').forEach(($el) => new ActivityLightbox($el));
};

const initMobileNavigation = () => {
    const toggle = document.querySelector('[data-mobile-nav-toggle]');
    const nav = document.querySelector('[data-mobile-nav]');

    if (!toggle || !nav) {
        return;
    }

    toggle.addEventListener('click', () => {
        const isOpen = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!isOpen));
        nav.hidden = isOpen;
        document.documentElement.classList.toggle('has-mobile-nav', !isOpen);
    });

    const getSubmenu = (trigger) => {
        const item = trigger.closest('li');

        return item ? [...item.children].find((child) => child.matches('[data-mobile-submenu]')) || null : null;
    };

    const setSubmenuState = (trigger, shouldExpand) => {
        const submenu = getSubmenu(trigger);
        const item = trigger.closest('li');

        trigger.setAttribute('aria-expanded', String(shouldExpand));
        item?.classList.toggle('is-open', shouldExpand);

        if (submenu) {
            submenu.hidden = !shouldExpand;
        }

        const siblingToggle = item?.querySelector('[data-mobile-submenu-toggle]');

        if (siblingToggle && siblingToggle !== trigger) {
            siblingToggle.setAttribute('aria-expanded', String(shouldExpand));
        }
    };

    nav.querySelectorAll('.mobile-menu__link--has-children, .mobile-utility-menu__link--has-children, .sub-mobile-menu__link--has-children, .sub-mobile-utility-menu__link--has-children, .sub-sub-mobile-menu__link--has-children, .sub-sub-mobile-utility-menu__link--has-children, .sub-sub-sub-mobile-menu__link--has-children, .sub-sub-sub-mobile-utility-menu__link--has-children').forEach((submenuTrigger) => {
        submenuTrigger.setAttribute('aria-expanded', submenuTrigger.closest('li')?.classList.contains('is-open') ? 'true' : 'false');

        submenuTrigger.addEventListener('click', (event) => {
            event.preventDefault();

            const isOpen = submenuTrigger.getAttribute('aria-expanded') === 'true';
            setSubmenuState(submenuTrigger, !isOpen);
        });
    });
};

const initSidebarNavigation = () => {
    const sidebars = [...document.querySelectorAll('.page__sidebar')];

    sidebars.forEach((sidebar) => {
        const stickyTop = parseFloat(window.getComputedStyle(sidebar).top) || 0;
        const nav = sidebar.querySelector('.sidebar-nav');
        let initialTop = 0;

        const recalculateTop = () => {
            initialTop = sidebar.getBoundingClientRect().top + window.scrollY;
        };

        const syncStickyState = () => {
            const isStuck = window.matchMedia('(min-width: 992px)').matches
                && window.scrollY >= initialTop - stickyTop;
            sidebar.classList.toggle('page__sidebar--stuck', isStuck);

            if (nav) {
                nav.classList.toggle('sidebar-nav--stuck', isStuck);
            }
        };

        recalculateTop();
        syncStickyState();
        window.addEventListener('scroll', syncStickyState, {passive: true});
        window.addEventListener('resize', () => {
            recalculateTop();
            syncStickyState();
        });
    });

    document.querySelectorAll('.sidebar-nav').forEach((nav) => {
        const links = [...nav.querySelectorAll('a[href*="#"]')].map((link) => {
            const url = new URL(link.href, window.location.origin);
            if (url.origin !== window.location.origin || url.pathname !== window.location.pathname || !url.hash) {
                return null;
            }

            const target = document.querySelector(decodeURIComponent(url.hash));
            if (!target) {
                return null;
            }

            return {link, target};
        }).filter(Boolean);

        if (!links.length) {
            return;
        }

        const getScrollOffset = () => {
            const header = document.querySelector('[data-site-header]');
            return (header ? header.getBoundingClientRect().height : 0) + 24;
        };

        const setActiveLink = () => {
            const fromTop = window.scrollY + getScrollOffset() + 1;
            let current = null;

            links.forEach(({target}) => {
                if (target.offsetTop <= fromTop) {
                    current = target;
                }
            });

            links.forEach(({link, target}) => {
                link.classList.toggle('sidebar-nav-menu__link--active', current === target);
            });
        };

        links.forEach(({link, target}) => {
            link.addEventListener('click', (event) => {
                event.preventDefault();
                window.scrollTo({
                    top: target.getBoundingClientRect().top + window.scrollY - getScrollOffset(),
                    behavior: 'smooth'
                });
            });
        });

        setActiveLink();
        window.addEventListener('scroll', setActiveLink, {passive: true});
        window.addEventListener('resize', setActiveLink);
    });
};

const initHeroSliders = ($wrapper) => {
    $wrapper.querySelectorAll('[data-hero-slider]').forEach(($el) => new HeroSlider($el));
};

(function() {
    window.initDom(document);
    initMobileNavigation();
    initSidebarNavigation();
})();
